import { useTranslation } from '@/hooks/useTranslation';
import { scaleCriteriaChoices } from '../picker/IroScalePicker';
import { CriteriaRatingTable } from './CriteriaRatingTable';
import { IroFormula } from './IroFormula';
import { ScaleValueDefinition } from '@/graphql/generated';

export function ScaleCriteriaDefinition({
  definitions,
}: {
  definitions: ScaleValueDefinition[];
}) {
  const { t } = useTranslation();
  const items = scaleCriteriaChoices();
  return (
    <div>
      <h1 className="p-8 bg-gray-50 border-b border-gray-100 title-h3 capitalize">
        {t('iro.criteria.scale.title')}
      </h1>
      <div className="p-8 space-y-8">
        <p className="">{t('iro.criteria.scale.definition')}</p>
        <hr />
        <div className="space-y-2">
          <h2 className="title-h4">{t('iro.criteria.rating.title')}</h2>
          <CriteriaRatingTable items={items} definitions={definitions} />
        </div>
        <hr />
        <div className="space-y-2">
          <h2 className="title-h4">{t('iro.criteria.formula.title')}</h2>
          <IroFormula />
        </div>
      </div>
    </div>
  );
}
